import {
  Button,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  notification,
  Row,
  Select,
  Drawer,
  Space,
  Tooltip,
} from "antd";
import { useEffect, useRef, useState } from "react";
import { dayjs } from "../../../../Utilities/dayjs";
import TdsTcsServices, {
  Limit_Type,
  Transaction_Type,
} from "../../../Services/TdsTcsServices";
import { NotificationType } from "../../../Common/Routing/PageRoute";
import { ITdsNature, TDSNature } from "./TDSNatures";
import { useClient } from "../../../Context/ClientContext";
import { CloseOutlined } from "@ant-design/icons";
import EntryLevelKeys from "../../../Common/EntryLevelKeys";
import { useHotkey } from "../../../Context/HotKeyContext";

interface IPropsTcs {
  open: boolean;
  setOpen: (value: boolean) => void;
  setTrigger: React.Dispatch<React.SetStateAction<boolean>>;
  editData?: any;
}

const AddTdsTaxRate = (props: IPropsTcs) => {
  const { showKeys } = useHotkey();
  // console.log("props: ", props);
  const autoCompleteRef = useRef<any>(null);
  const { currentClient } = useClient();
  const [form] = Form.useForm();
  const [saveButtonLoading, setSaveButtonLoading] = useState<boolean>(false);
  const [api, contextHolder] = notification.useNotification();
  const [type, setType] = useState<Transaction_Type>(Transaction_Type.Domestic);

  const openNotification = (type: NotificationType, message: string) => {
    api[type]({
      message: "",
      description: message,
      duration: 2,
      closeIcon: false,
      style: {
        width: 350,
      },
    });
  };
  useEffect(() => {
    setTimeout(() => {
      if (autoCompleteRef.current) {
        autoCompleteRef.current.focus();
      }
    }, 100);
  }, []);
  useEffect(() => {
    if (props.editData?.id) {
      const findData = TDSNature.find(
        (x: ITdsNature) => x.key === props.editData?.sectionKey
      );
      form.setFieldsValue({
        section: {
          label: `${findData?.section} - ${findData?.title}`,
          value: findData?.key,
          key: findData?.key,
          title: findData?.section,
        },

        natureOfPayment: props.editData?.natureOfPayment,
        limitType: props.editData?.limitType,
        rateDetail: props.editData?.rateDetail,
        transactionType: props.editData?.transactionType,
        effectiveFrom:
          props.editData?.effectiveFrom !== undefined &&
          props.editData?.effectiveFrom !== null &&
          props.editData?.effectiveFrom !== ""
            ? dayjs(
                dayjs(props.editData?.effectiveFrom).format("DD/MM/YYYY"),
                "DD/MM/YYYY"
              )
            : undefined,
        effectiveTo:
          props.editData?.effectiveTo !== undefined &&
          props.editData?.effectiveTo !== null &&
          props.editData?.effectiveTo !== ""
            ? dayjs(
                dayjs(props.editData?.effectiveTo).format("DD/MM/YYYY"),
                "DD/MM/YYYY"
              )
            : undefined,
        form: props.editData?.form,
      });
      setType(props.editData?.transactionType);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.editData?.id]);

  const saveTDS = () => {
    form.validateFields().then(async (value) => {
      try {
        setSaveButtonLoading(true);
        const postData = {
          ...value,
          sectionKey: value?.section.value,
          section: value?.section.title,
          effectiveFrom:
            value?.effectiveFrom !== undefined
              ? dayjs(
                  dayjs(value?.effectiveFrom).format("DD/MM/YYYY"),
                  "DD/MM/YYYY"
                )
              : null,
          effectiveTo:
            value?.effectiveTo !== undefined
              ? dayjs(
                  dayjs(value?.effectiveTo).format("DD/MM/YYYY"),
                  "DD/MM/YYYY"
                )
              : null,
        };

        console.log("data", value);

        const res = await TdsTcsServices.postTDS(
          currentClient?.id!,
          postData,
          props.editData?.id
        );

        if (res.status) {
          openNotification("success", `TDS rate added successfully..`);
          setSaveButtonLoading(false);
          props.setOpen(false);
          props.setTrigger((x: boolean) => !x);
        } else {
          setSaveButtonLoading(false);
          // openNotification("error", res?.message);
          setSaveButtonLoading(false);
          res?.message && openNotification("error", res.message);
        }
      } catch (err: any) {
        console.log(err);
        // openNotification("error", err);
        setSaveButtonLoading(false);
        err && openNotification("error", err);
      }
    });
  };
  const setValue = (selSection: any) => {
    console.log("Section data: ", selSection);

    const findData = TDSNature.find(
      (x: ITdsNature) => x.key === selSection.key
    );

    if (findData) {
      if (props.editData?.section !== findData.section) {
        console.log(findData);
        form.setFieldsValue({
          section: selSection,
          natureOfPayment: findData?.title,
          limitType: findData?.term,
          rateDetail: {
            thresholdLimit: findData?.thresholdLimit,
            rates: {
              indHUFRate: findData.rates.indHUF,
              otherRate: findData.rates.others,
              ifPANNotRate: findData.rates.ifNotPAN,
            },
          },
          transactionType: findData?.type,
          form: findData?.form,
          effectiveFrom:
            findData?.effectiveFrom !== undefined &&
            findData?.effectiveFrom !== ""
              ? dayjs(
                  dayjs(findData?.effectiveFrom, "DD/MM/YYYY").format(
                    "DD/MM/YYYY"
                  ),
                  "DD/MM/YYYY"
                )
              : undefined,
          effectiveTo:
            findData?.effectiveTo !== undefined && findData?.effectiveTo !== ""
              ? dayjs(
                  dayjs(findData?.effectiveTo, "DD/MM/YYYY").format(
                    "DD/MM/YYYY"
                  ),
                  "DD/MM/YYYY"
                )
              : undefined,
        });
        setType(findData?.type);
      } else {
        form.setFieldsValue({
          section: props.editData?.section,
          natureOfPayment: props.editData?.natureOfPayment,
          limitType: props.editData?.limitType,
          rateDetail: props.editData?.rateDetail,
          transactionType: props.editData?.transactionType,
          form: props.editData?.form,
          effectiveFrom:
            props.editData?.effectiveFrom !== undefined &&
            props.editData?.effectiveFrom !== ""
              ? dayjs(
                  dayjs(props.editData?.effectiveFrom, "DD/MM/YYYY").format(
                    "DD/MM/YYYY"
                  ),
                  "DD/MM/YYYY"
                )
              : undefined,
          effectiveTo:
            props.editData?.effectiveTo !== undefined &&
            props.editData?.effectiveTo !== ""
              ? dayjs(
                  dayjs(props.editData?.effectiveTo, "DD/MM/YYYY").format(
                    "DD/MM/YYYY"
                  ),
                  "DD/MM/YYYY"
                )
              : undefined,
        });
        setType(props.editData?.transactionType);
      }
    }
  };

  EntryLevelKeys({
    save: () => saveTDS(),
    cancel: () => {
      props.setOpen(false);
    },
  });

  return (
    <>
      <Drawer
        maskClosable={false}
        title={props.editData?.id ? "Update TDS Rate" : "Add TDS Rate"}
        open={props.open}
        width={"500px"}
        // centered
        onClose={() => props.setOpen(false)}
        closable={false}
        extra={
          <Space>
            <CloseOutlined onClick={() => props.setOpen(false)} />
          </Space>
        }
        footer={
          <div style={{ textAlign: "right" }}>
            <Tooltip
              title={<p>ALT+C</p>}
              placement="bottomLeft"
              open={showKeys}
            >
              <Button
                onClick={() => {
                  form.resetFields();
                  props.setOpen(false);
                }}
              >
                Cancel
              </Button>
            </Tooltip>
            <Tooltip
              title={<p>ALT+S</p>}
              placement="bottomLeft"
              open={showKeys}
            >
              <Button
                type="primary"
                onClick={() => saveTDS()}
                style={{ width: "80px" }}
                loading={saveButtonLoading}
                className="modelSaveButtonMargin"
              >
                {props.editData?.id ? "Update" : "Save"}
              </Button>
            </Tooltip>
          </div>
        }
      >
        <Form
          form={form}
          layout="vertical"
          labelWrap={true}
          autoComplete="off"
          colon={false}
          labelAlign="left"
          name="tscDetail"
          requiredMark={true}
          initialValues={{ limitType: Limit_Type.Yearly, transactionType: 0 }}
        >
          <Row gutter={14}>
            <Col sm={24}>
              <Form.Item
                className="input-item"
                // className="inputBoxMb8"
                name="section"
                label="Section"
                rules={[{ required: true, message: "Section is required" }]}
              >
                {/* <Input /> */}
                <Select
                  ref={autoCompleteRef}
                  showSearch
                  optionFilterProp="label"
                  labelInValue
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? "")
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? "").toLowerCase())
                  }
                  options={TDSNature?.map((x: any, index: number) => ({
                    label: `${x.section} - ${x.title}`,
                    value: x.key,
                    key: x.key,
                    title: x.section,
                  }))}
                  onChange={(e) => setValue(e)}
                />
              </Form.Item>
            </Col>
            <Col sm={24}>
              <Form.Item
                className="input-item"
                name="natureOfPayment"
                label="Nature of Payment"
                rules={[
                  { required: true, message: "Nature of payment is required" },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col sm={12} xs={24}>
              <Form.Item
                className="input-item"
                label="Effective From"
                name="effectiveFrom"
                style={{ paddingRight: "1px" }}
              >
                <DatePicker
                  format="DD/MM/YYYY"
                  style={{ width: "100%" }}
                  disabledDate={(current) =>
                    current < dayjs("1900-01-01", "YYYY-MM-DD").add(-1, "day")
                  }
                />
              </Form.Item>
            </Col>
            <Col sm={12} xs={24}>
              <Form.Item
                className="input-item"
                label="Effective To"
                name="effectiveTo"
              >
                <DatePicker
                  format="DD/MM/YYYY"
                  style={{ width: "100%" }}
                  disabledDate={(current) =>
                    current < dayjs("1900-01-01", "YYYY-MM-DD").add(-1, "day")
                  }
                />
              </Form.Item>
            </Col>
            <Col sm={12} xs={24}>
              <Form.Item
                className="input-item"
                label="Limit Type"
                name="limitType"
              >
                <Select
                  options={[
                    { label: "Yearly", value: Limit_Type.Yearly },
                    { label: "Monthly", value: Limit_Type.Monthly },
                    {
                      label: "Per Transaction",
                      value: Limit_Type.PerTransaction,
                    },
                  ]}
                />
              </Form.Item>
            </Col>

            <Col sm={12} xs={24}>
              <Form.Item
                className="input-item"
                label="Transaction Type"
                name="transactionType"
              >
                <Select
                  options={[
                    { label: "Domestic", value: Transaction_Type.Domestic },
                    {
                      label: "International",
                      value: Transaction_Type.International,
                    },
                  ]}
                  onChange={(e) => setType(e)}
                />
              </Form.Item>
            </Col>
            <Col sm={12} xs={24}>
              <Form.Item className="input-item" label="Form No." name="form">
                <Input />
              </Form.Item>
            </Col>
          </Row>

          {/* Rates Block */}
          <Divider
            orientation="left"
            orientationMargin="0"
            className="dividertext"
            style={{ marginTop: "11px", marginBottom: "11px" }}
          >
            {type === Transaction_Type.Domestic ? (
              <>
                <p style={{ fontWeight: 600 }}>Domestic</p>
              </>
            ) : (
              <>
                <p style={{ fontWeight: 600 }}>International</p>
              </>
            )}
          </Divider>
          <Row gutter={14}>
            <Col sm={12} xs={24}>
              <Form.Item
                label="Threshold Limit"
                name={["rateDetail", "thresholdLimit"]}
                className="input-item"
              >
                <InputNumber
                  min={0}
                  // max={100}
                  style={{ width: "100%" }}
                  controls={false}
                />
              </Form.Item>
            </Col>
            <Col sm={12} xs={24}>
              <Form.Item
                label="Ind / HUF Rate"
                name={["rateDetail", "rates", "indHUFRate"]}
                className="input-item"
                rules={[
                  {
                    required: true,
                    message: "Ind / HUF rate is required",
                  },
                ]}
              >
                <InputNumber
                  min={0}
                  style={{ width: "100%" }}
                  controls={false}
                />
              </Form.Item>
            </Col>
            <Col sm={12} xs={24}>
              <Form.Item
                label="Other Rate"
                name={["rateDetail", "rates", "otherRate"]}
                className="input-item"
              >
                <InputNumber
                  min={0}
                  style={{ width: "100%" }}
                  controls={false}
                />
              </Form.Item>
            </Col>
            <Col sm={12} xs={24}>
              <Form.Item
                label="Rate If PAN not available"
                name={["rateDetail", "rates", "ifPANNotRate"]}
                className="input-item"
              >
                <InputNumber
                  min={0}
                  style={{ width: "100%" }}
                  controls={false}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>
      {contextHolder}
    </>
  );
};

export default AddTdsTaxRate;
